import { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Imports => Constants
import { KEYS } from '@opp/ui-kit';

// Imports => Utilities
import { AcIsSet, AcIsArray } from '@opp/ui-kit';

// Imports => Atoms
import AcTicketListItem from '@atoms/ac-ticket-list-item/ac-ticket-list-item';

const _CLASSES = {
  MAIN: 'ac-ticket-list',
  CONTAINER: 'ac-ticket-list__container',
};

const AcTicketList = ({ items = [], className }) => {
  const getContainerClassNames = useMemo(() => {
    return clsx(_CLASSES.CONTAINER);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, className);
  }, [className]);

  const renderItems = useMemo(() => {
    if (!AcIsSet(items) || !AcIsArray(items)) return null;

    // Sort tickets by
    // awaiting
    // open
    // replied
    // on hold
    // closed

    const order = {
      [KEYS.REPLIED]: 0,
      [KEYS.AWAITING]: 1,
      [KEYS.ONHOLD]: 2,
      [KEYS.OPEN]: 3,
      [KEYS.CLOSED]: 4,
    };

    let sorted_items = [];
    let temp_arr = [];

    for (let k in order) {
      temp_arr = items.filter((o) => o.status === k);
      sorted_items = [...sorted_items, ...temp_arr];
    }

    const collection = sorted_items;
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const item = collection[n];

      const object = (
        <AcTicketListItem key={`ac-ticket-list-item-${item.uid}`} data={item} />
      );

      result.push(object);
    }

    return result;
  }, [items]);

  return (
    <div className={getMainClassNames}>
      <div className={getContainerClassNames}>{renderItems}</div>
    </div>
  );
};

AcTicketList.propTypes = {
  /**
     * For CSS customization
     */
  className: PropTypes.string,
};

export default memo(AcTicketList);
